import { showMessage } from "react-native-flash-message";

const flash = (message, type, duration) => {
  showMessage({
    message: message,
    type: type,
    textStyle: { fontFamily: "avenir", marginHorizontal: 5 },
    titleStyle: { fontFamily: "avenir-h" },
    floating: true,
    hideOnPress: true,
    duration: duration ? duration : 3000,
    icon: { icon: type, position: "left" },
  });
};

export default flash;
